module.exports = __webpack_public_path__ + "img/hic-respiratory-diseases-female.ced3bc35.png";